export default {
  toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
  },

  selectOption(minutes) {
    if (minutes == '') {
      this.duration = `25min`
      this.$store.dispatch('interviewState/setInterviewDuration', 25)
    } else {
      this.duration = `${minutes}min`
      this.$store.dispatch('interviewState/setInterviewDuration', minutes)
    }
    
    this.closeDropdown()
  },

  // 用于点击外部关闭下拉菜单
  closeDropdown() {
    if (this.dropdownVisible) {
      this.dropdownVisible = false;
    }
  },

  // 切换语言选择下拉菜单的可见性
  toggleLanguageDropdown() {
    this.languageDropdownVisible = !this.languageDropdownVisible;
  },

  // 选择具体的语言选项
  selectLanguage(value) {
    if (value == 1) {
      this.language = '中文'
    } else if (value == 2) {
      this.language = '英语'
    }
    if (this.language == '中文') {
      this.$store.dispatch('interviewState/setInterviewLanguage', 1);
    }
    if (this.language == '英语') {
      this.$store.dispatch('interviewState/setInterviewLanguage', 2);
    }
    this.languageDropdownVisible = false;
  },

  // 关闭语言选择下拉菜单
  closeLanguageDropdown() {
    if (this.languageDropdownVisible) {
      this.languageDropdownVisible = false;
    }
  }
}; 